<template>
  <div>
    <el-dialog
        lock-scroll
        :modal-append-to-body="false"
        :append-to-body="true"
        :title="$lang('批量导入')"
        :close-on-click-modal="false"
        :visible.sync="visible"
        @close="close"
        width="900px"
        top="0px"
    >
      <div class="overflow">
        <div class="upload-item">
          <div class="upload" >
            <el-upload
                ref="upload2"
                :action="uploadUrl"
                :headers="header"
                :data="{type:2}"
                :multiple="false"
                list-type="text"
                :limit="1"
                accept=".xls,.xlsx"
                :show-file-list="false"
                :on-change="handleChange2"
                :on-success="onSuccess2"
                :on-error="onError2"
                :auto-upload="false"
                :on-exceed="onExceed"
            >
              <template slot="default">
                <div class="upload-area">
                  <svg class="icon" aria-hidden="true" v-if="!isActive2">
                    <use xlink:href="#iconwendang-moren"></use>
                  </svg>
                  <svg class="icon" aria-hidden="true" v-else>
                    <use xlink:href="#iconwendang-jihuo"></use>
                  </svg>
                  <p class="name">{{text2 || $lang('点击此处选择Excel文档')}}</p>
                </div>
              </template>
            </el-upload>
          </div>
          <div class="button">
            <el-button type="info select" @click="clearFile2" v-if="isActive2">{{ $lang('重新选择') }}</el-button>
            <el-button type="primary" @click="upload2" :loading="upLoading2" v-if="text2 && noError2">{{ $lang('立即上传') }}</el-button>
          </div>
        </div>
      </div>
      <div class="tips">
        <p>{{ $lang('1、请按照模板内容字段内容顺序正确填写，并按照指定模板内容导入；') }}</p>
        <p>{{ $lang('2、单次最多导入1000条数据；') }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { INTER_EXCEL_IMPORT } from '@constants'
import { mapGetters } from 'vuex'
export default {
  name: 'UploadFile',
  props: {
    spotType: {
      type: String,
      default: '',
    },
    orderTemplate: {
      type: Number,
      default: 0,
    },
    uploadUrl: {
      type: String,
      default: INTER_EXCEL_IMPORT
    }
  },
  data () {
    return {
      visible: false,
      text2: '',
      isActive2: false,
      upLoading2: false,
      noError2: true,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      lang: 'lang'
    }),
    // 用户信息
    userInfo () {
      return this.$store.state.base.user || {}
    },
    header () {
      return {
        'authToken': this.userInfo.token,
        'language': localStorage.getItem('lang') || this.lang
      }
    },
  },

  methods: {
    open() {
      this.visible = true
    },
    handleChange2 (file, fileList) {
      if (!file || file.status !== 'ready') {
        return
      }
      this.text2 = file.name
      this.isActive2 = true
    },
    onSuccess2 (data) {
      if (data.code === 1) {
        this.$emit('success', data, 2)
        this.close()
        this.clearFile2()
      } else {
        this.$message.error(data.msg)
        this.noError2 = false
      }
      this.upLoading2 = false
    },
    clearFile2 () {
      this.$nextTick(() => {
        this.$refs.upload2.clearFiles()
      })
      this.text2 = ''
      this.isActive2 = false
      this.noError2 = true
    },
    onError2 () {
      this.upLoading2 = false
    },
    upload2 (item) {
      this.upLoading2 = true
      this.$refs.upload2.submit()
    },
    onExceed (file, fileList) {
      this.$message.error(this.$lang('模板已存在,请重新选择'))
    },
    close () {
      this.visible = false
      this.$emit('input', this.visible)
      this.$emit('change', this.visible)
      this.clearFile2()
    },
  },
}
</script>

<style scoped lang="scss" scoped>
.overflow {
  text-align: center;
  border-bottom: 1px dashed rgba(238, 238, 238, 1);
  display: flex;
  justify-content: space-around;
}
.overflow p {
  font-size: 12px;
  color: #999;
}
.upload-area {
  margin-top: 45px;
  .file {
    font-size: 72px;
    background-image: linear-gradient(to bottom, #e0bd7b, #cfa561);
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .name {
    font-size: 14px;
  }
  .icon {
    font-size: 48px;
  }
}
.upload {
  display: inline-block;
  text-align: center;
  width: 180px;
  height: 170px;
  background: #f7f7f9;
  border-radius: 4px;
  border: 1px solid transparent;
  margin-top: 25px;
}
.tips {
  margin-top: 16px;
  font-size: 12px;
  color: #999;
}
.button {
  height: 60px;
  box-sizing: border-box;
  padding: 10px 15px;
}
button.select.is-disabled {
  color: #999;
  border-color: #ebeef5;
  background-color: #ebeef5;
}
</style>
